import MUIDataTable from "mui-datatables";
import { useEffect, useState } from "react";

const Tickets = (props) => {
    const [ticketsData, setTicketsData] = useState([]);

    useEffect(() => {
        let data = props.data;

        // Check for empty data and skip processing
        if (data.length === 0) return;

        // Check for undefined values and replace
        data = data.map((item) => {
            Object.keys(item).forEach((key) => {
                if (item[key] === undefined || item[key] === null) {
                    item[key] = "-";
                }
            });
            return item;
        });

        setTicketsData(data);
    }, [props.data]);

    const columns = [
        {
            name: "ticket_slug",
            label: "Slug",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "ticket_created",
            label: "Date Created",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                    },
                }),
                sortCompare: (order) => (a, b) => {
                    const dateA = new Date(a.data);
                    const dateB = new Date(b.data);
                    return (dateA - dateB) * (order === "asc" ? 1 : -1);
                },
            },
        },
        {
            name: "ticket_title",
            label: "Title",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "180px",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "180px",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "ticket_reporter",
            label: "Reporter",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "150px",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "150px",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "ticket_status",
            label: "Status",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "ticket_assignedto",
            label: "Assigned To",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "150px",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "150px",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "ticket_product",
            label: "Product",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "ticket_last_updated",
            label: "Last Updated",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                    },
                }),
                sortCompare: (order) => (a, b) => {
                    const dateA = new Date(a.data);
                    const dateB = new Date(b.data);
                    return (dateA - dateB) * (order === "asc" ? 1 : -1);
                },
            },
        },
    ];

    const options = {
        responsive: "standard",
        selectableRows: "none",
        filter: false,
        sort: true,
        sortOrder: { name: "ticket_created", direction: "desc" },
        viewColumns: false,
        print: false,
        download: false,
        search: false,
        columnOrder: null,
        fixedHeader: true,
        pagination: true,
        rowsPerPage: 15,
        rowsPerPageOptions: [15, 30, 50, 100],
    };

    return (
        <div className="mt-12 flex w-full flex-col">
            <h4 className="pb-2">Capacity Tickets</h4>

            <MUIDataTable
                data={ticketsData}
                columns={columns}
                options={options}
                style={{ marginTop: "50px" }}
                className="ngShadow"
            />
        </div>
    );
};

export default Tickets;
